import './Main.css'

import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useWizard } from '@/common/wizard/wizard'
import { useAppContext } from '@/context/app'
import { WizardData } from './Model'
import { StaticPaginatedTable, StaticPaginatedTableState } from '@/components/search/StaticPaginatedTable'
import { TimeDHM } from '@/components/Elements/time'
import { secondsToDHM, toLocalISOString } from '@/common/time'
import { fetchPDF } from '@/common/fetch'
import { MachineName } from '@/components/machine'
import { Spinner } from '@/components/spinner'

interface AIQuery {
  lang: string
  code: string
}

interface AIResponse {
  answer: string
}


export const ErrorCodesWizardResult = () => {
  const { services, session, translates } = useAppContext()
  const { wizardData } = useWizard<WizardData>()
  const [data, setData] = useState<AIResponse>()

  function refresh() {
    const queryData: AIQuery = {
      code: wizardData.errorcode,
      lang: session?.user.lang || 'en'
    }
    services.session.fetchWithToken(`/api/communal/ai/machines/${wizardData.machineId}/errorcode/ask`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(queryData)
    }).then((response) => {
      return response.json()
    }).then((respData: AIResponse) => {
      setData(respData)
    })
  }

  useEffect(refresh, [])

  if (translates === undefined || wizardData === undefined || data === undefined) {
    return <Spinner />
  }

  return <>
    <div>
      <h2>{wizardData.errorcode}</h2>
      <p className='answer'>{data.answer}</p>
    </div>
  </>
}